import { SET_BULK_ADVANCE_COMPOSER, SET_PARAMS_ADVANCE_COMPOSER, CLEAR_PARAMS_ADVANCE_COMPOSER } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    status: "",
    composer_id: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_ADVANCE_COMPOSER:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_ADVANCE_COMPOSER:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_ADVANCE_COMPOSER:
            return initialState;
        default:
            return state;
    }
}
